import React, { useState, useEffect } from "react";
import { Doughnut } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import axios from "axios";

ChartJS.register(ArcElement, Tooltip, Legend);

const apiUrl = process.env.REACT_APP_API_URL;

export const DoughnutChartFiche = () => {
  const [ficheData, setFicheData] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.post(`${apiUrl}IHM/api/dashboard.php?fiche`);
        setFicheData(response.data);
      } catch (error) {
        console.error("Erreur lors récupération", error);
      }
    };
    fetchData();
  }, []);

  if (ficheData.length === 0) return null;

  const dataValues = ficheData.map(item => parseInt(item.nb_modifications, 10));
  const total = dataValues.reduce((acc, val) => acc + val, 0);
  const capitalize = (s) => {
    if (!s) return "Inconnu";
    return s.charAt(0).toUpperCase() + s.slice(1);
  };
  const labels = ficheData.map((item) => {
    const value = parseInt(item.nb_modifications, 10);
    const percentage = ((value / total) * 100).toFixed(1);
    return `${capitalize(item.adminNote) || "Inconnu"} (${percentage}%)`;
  });

  const colorMap = {
    "cathy": "#9fcd58",
    "sophia": "#FEC868",
    "amandine": "#b777ff"
  };
  const defaultColor = "#CCCCCC";

  const colors = ficheData.map((item) => {
    const name = item.adminNote || "Inconnu";
    return colorMap[name] || defaultColor;
  });

  const data = {
    labels,
    datasets: [
      {
        data: dataValues,
        backgroundColor: colors,
        borderColor: "#fff",
        borderWidth: 1
      }
    ]
  };

  const options = {
    responsive: true,

    plugins: {
      legend: {
        position: "bottom"
      },
      tooltip: {
        callbacks: {
          label: (ctx) => {
            const value = ctx.raw;
            const percentage = ((value / total) * 100).toFixed(1);
            return `${ctx.label}: ${value} (${percentage}%)`;
          }
        }
      }
    }
  };

  return (
    <div style={{width : 250}}>
      <Doughnut data={data} options={options} />
    </div>
  );
};
